import { render, staticRenderFns } from "./SuccessResetPassword.vue?vue&type=template&id=421c2d38&"
import script from "./SuccessResetPassword.vue?vue&type=script&lang=js&"
export * from "./SuccessResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./SuccessResetPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/kresno/Documents/REPO/FB/WEB/FASE_1/admin-dasboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
installComponents(component, {VApp})
